import { external as externalScriptLoader } from '../../utils/script'
import { externalScriptsConfig } from '../config/externalScripts'
export default function initTaboola() {
  externalScriptLoader.load({
    name: externalScriptsConfig.taboola.name,
    loadNow: true,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/taboolaInitializer.js